module.exports = __webpack_public_path__ + "static/media/img14.8142ef17.jpg";